import { Component, Input } from '@angular/core';

/**
 * @deprecated use version from libs
 */
@Component({
    selector: 'ins-cat',
    templateUrl: 'cat.component.html',
    styleUrls: ['cat.component.scss']
})
export class CatComponent {
    @Input() reverse: boolean = false;
    @Input() fast: boolean = false;
    @Input() slow: boolean = false;
    @Input() small: boolean = false;

    constructor() { }
}
